import { FiSettings, FiPlusCircle, FiImage, FiShare2, FiMapPin } from "react-icons/fi";
import React from 'react';

export const THEME = "#B08D55";


export const QUICK_ACTIONS = [
    {
        title: "Edit Profile",
        icon: React.createElement(FiSettings),
        link: "/profile",
        minTier: 0,
        desc: "Update details"
    },
    {
        title: "Add Services",
        icon: React.createElement(FiPlusCircle),
        link: "/services",
        minTier: 0,
        desc: "List your offerings"
    },
    {
        title: "Upload Photos",
        icon: React.createElement(FiImage),
        link: "/gallery",
        minTier: 2, // Gold+
        desc: "Update gallery"
    },
    {
        title: "Manage Socials",
        icon: React.createElement(FiShare2),
        link: "/social",
        minTier: 2, // Gold+
        desc: "Link accounts"
    },
    {
        title: "Update Location",
        icon: React.createElement(FiMapPin),
        link: "/profile",
        minTier: 0,
        desc: "Business address"
    }
];

export const TIER_LIMITS = {
    maxImages: [0, 10, 25, 15],
    maxVideos: [0, 0, 3, 5]
};

export const REVENUE_GOALS = [
    { name: "Silver", goal: 2500 },
    { name: "Gold", goal: 6000 },
    { name: "Platinum", goal: 10000 }
];


